import React, { useState } from "react";
import BrandRow from "./BrandRow";
import { useQuery } from "react-query";
import Loading from "../Shared/Loading";
import BrandDeleteModal from "./BrandDeleteModal";

const AllBrands = () => {
  const [modalData, setModalData] = useState({});
  const [showBrandDeleteModal, setShowBrandDeleteModal] = useState(false);

  const {
    data: allBrands,
    isLoading,
    refetch,
  } = useQuery("allBrands", () =>
    fetch("https://evening-peak-35730.herokuapp.com/brands").then((res) => {
      return res.json();
    })
  );

  if (isLoading) {
    return <Loading></Loading>;
  }

  return (
    <section>
      <div>
        <h1 className="text-xl text-accent text-center my-4 font-bold">
          All Brands List
        </h1>
        <div className="overflow-x-auto">
          <table className="table table-zebra w-full">
            <thead>
              <tr>
                <th>#</th>
                <th>Brand's Image</th>
                <th>Brand's Name</th>
                <th>Brand's Slug</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {allBrands?.map((brand, index) => (
                <BrandRow
                  key={brand._id}
                  index={index}
                  brand={brand}
                  setShowBrandDeleteModal={setShowBrandDeleteModal}
                  setModalData={setModalData}
                ></BrandRow>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showBrandDeleteModal && (
        <BrandDeleteModal
          brand={modalData}
          refetch={refetch}
          setShowBrandDeleteModal={setShowBrandDeleteModal}
          setModalData={setModalData}
        ></BrandDeleteModal>
      )}
    </section>
  );
};

export default AllBrands;
